import { useToast } from "@chakra-ui/react";
import { approvalKasDeposit, getKasDetail } from "apis/kas_deposit";
import Card from "components/card";
import InputText from "components/Form/InputText";
import Confirmation from "components/Modal/Confirmation";
import { getUser } from "helper/localstorage";
import moment from "moment";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { currency } from "helper/index";

const ModalApprovalKasDeposit = ({ approval, setApproval, callback }) => {
  const toast = useToast();
  const { id } = getUser();
  const [isLoading, setIsLoading] = useState(false);
  const [kasData, setKasData] = useState([]);

  const idsKas = approval?.data?.kas_deposit_detail
    ?.map((d) => d?.kas_data?.id_kas)
    .filter((id) => id);

  useEffect(() => {
    if (approval.show && idsKas && idsKas.length > 0) {
      fetchKasData();
    }
  }, [approval.show, idsKas?.length]);

  const fetchKasData = async () => {
    if (!idsKas || idsKas.length === 0) return;

    setIsLoading(true);
    try {
      const requests = idsKas.map((kasId) =>
        getKasDetail(kasId)
          .then((response) => response.data)
          .catch((error) => {
            console.error(`Failed to fetch data for ID ${kasId}:`, error);
            return null;
          })
      );

      const results = await Promise.allSettled(requests);

      const successData = results
        .filter((result) => result.status === "fulfilled" && result.value)
        .map((result) => result.value);

      setKasData(successData);
    } catch (error) {
      console.error("Error fetching kas data:", error);
      toast({
        title: "Gagal mengambil data kas",
        status: "error",
        isClosable: true,
        position: "top-center",
      });
    } finally {
      setIsLoading(false);
    }
  };

  console.log(kasData);

  return (
    <Confirmation
      isOpen={approval.show}
      onClose={() => setApproval({ show: false, data: null })}
      modalTitle="Approval Setoran Kas"
      isLoading={isLoading}
      onSubmit={async () => {
        try {
          setIsLoading(true);

          await approvalKasDeposit({
            id_kas_deposit: approval?.data?.id_kas_deposit,
            id_user: id,
            approval_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            approval_notes: approval?.data?.approval_notes,
          });

          toast({
            title: "Approval kas deposit berhasil",
            status: "success",
            isClosable: true,
            position: "top-center",
          });

          // Call the callback function
          await callback();
        } catch (error) {
          console.error("Error in approval process:", error);
          toast({
            title: "Gagal approval kas deposit",
            description:
              error.message || "Terjadi kesalahan saat memproses approval",
            status: "error",
            isClosable: true,
            position: "top-center",
          });
        } finally {
          setIsLoading(false);
        }
      }}
      submitButtonProps={{
        variant: "DEFAULT",
        isDisabled: isLoading,
      }}
    >
      <span>Apakah anda yakin ingin memproses setoran kas ini?</span>

      <div className="flex flex-col mt-2">
        <span className="min-w-[120px] font-medium">Bukti</span>
        <img
          className="h-[83px] w-[83px] rounded-lg"
          src={approval?.data?.attachment}
          alt="bukti"
        />
      </div>

      {/* Main summary card */}
      {kasData?.map((k) => (
        <Card extra={`p-4 pt-0 mt-4 border-[1px] rounded-[20px]`}>
          <div className="flex gap-4">
            <div className="mt-4">
              <div className="flex flex-col items-start leading-none">
                <div className="flex items-center gap-2">
                  <span className="min-w-[120px] font-medium">Buka Kasir</span>
                </div>
              </div>
              <div className="mt-0.5 text-sm text-gray-600">
                {moment(k.date_open).format("DD MMMM YYYY")}
              </div>
            </div>
            <div className="mt-4">
              <div className="flex flex-col items-start leading-none">
                <div className="flex items-center gap-2">
                  <span className="min-w-[120px] font-medium">Tutup Kasir</span>
                </div>
              </div>
              <div className="mt-0.5 text-sm text-gray-600">
                {moment(k.date_close).format("DD MMMM YYYY")}
              </div>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="mt-4">
              <div className="flex flex-col items-start leading-none">
                <div className="flex items-center gap-2">
                  <span className="min-w-[120px] font-medium">
                    Penerimaan Kasir
                  </span>
                </div>
                <div className="mt-2 flex items-center gap-4">
                  <div className="flex flex-col items-start leading-none">
                    <div className="flex items-center gap-2">
                      <span className="font-medium">Tunai</span>
                    </div>
                  </div>
                  <div className="mt-0.5 text-sm text-gray-600">
                    {currency(
                      k.paid_transaction_sum
                        ?.filter((p) => p.payment_method_name === "Tunai")
                        ?.reduce(
                          (prev, curr) => prev + curr?.payment_method_value,
                          0
                        )
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex flex-col items-start leading-none">
                    <div className="flex items-center gap-2">
                      <span className="font-medium">Piutang</span>
                    </div>
                  </div>
                  <div className="mt-0.5 text-sm text-gray-600">
                    {" "}
                    {currency(
                      k.paid_transaction_sum
                        ?.filter((p) => p.payment_method_name === "Piutang")
                        ?.reduce(
                          (prev, curr) => prev + curr?.payment_method_value,
                          0
                        )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      ))}

      <div className="mt-4 flex items-center justify-center gap-4">
        <div className="flex flex-col items-start leading-none">
          <div className="flex text-lg items-center gap-2">
            <span className="font-medium">Tunai yang harus disetorkan</span>
          </div>
        </div>
        <div className="mt-0.5 text-gray-600">
          {currency(approval?.data?.total_amount)}
        </div>
      </div>

      <InputText
        placeholder="Catatan"
        label="Catatan"
        extra="min-w-[430px] mt-4"
        value={approval?.data?.approval_notes}
        onChange={(e) => {
          setApproval((prev) => ({
            ...prev,
            data: { ...prev.data, approval_notes: e.target.value },
          }));
        }}
      />
    </Confirmation>
  );
};

export default ModalApprovalKasDeposit;
